import { render, staticRenderFns } from "./ScratchPad.vue?vue&type=template&id=0c44e3f8&scoped=true"
import script from "./ScratchPad.vue?vue&type=script&lang=js"
export * from "./ScratchPad.vue?vue&type=script&lang=js"
import style0 from "./ScratchPad.vue?vue&type=style&index=0&id=0c44e3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c44e3f8",
  null
  
)

export default component.exports